module.exports = __webpack_public_path__ + "img/ticket-footer.715c49de.png";